

export const STATE_TYPE = {
    ENABLE: '0',//启用
    DISABLE: '1',//禁用
};
export const INPUT_TYPE = {
    SELECT:'select',//下拉框
    TEXT: 'text',//输入框
}